import { useState } from "react";
import "./ProductPage.scss";
import { useTranslation } from "react-i18next";

export const HowItWorks = ({ products }) => {
  const { t } = useTranslation("productModule");
  const [isOpen, setIsOpen] = useState(false);

  // Check if any product has good_ingredient
  const hasGoodIngredients = products.some(
    (product) => product.score !== undefined,
  );

  if (!hasGoodIngredients) return null;

  return (
    <div className="how-it-works-container">
      <div className="how-it-works-header" onClick={() => setIsOpen(!isOpen)}>
        <span className="how-it-works-title">{t("how-it-works")}</span>
        <svg
          className={`arrow ${isOpen ? "open" : ""}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </div>
      {isOpen && (
        <div className="how-it-works-content">
          <p className="how-it-works-subtext">
            {t("how-it-works-description")}
          </p>
          <div className="how-it-works-items-wrapper">
            <div className="how-it-works-item">
              <p className="pill best-fit">{t("best-fit-tag")}</p>
              <p className="item-text">{t("best-fit-tag-description")}</p>
            </div>
            <div className="how-it-works-item">
              <p className="pill very-good">{t("very-good-tag")}</p>
              <p className="item-text">{t("very-good-tag-description")}</p>
            </div>
            <div className="how-it-works-item">
              <p className="pill good">{t("good-tag")}</p>
              <p className="item-text">{t("good-tag-description")}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
